import { ButtonProps, Theme, Typography } from '@mui/material';
import { OutlinedButton } from '@shared/components';

interface Props {
  name: string;
}

export const OrgUnitAssortmentHeading: React.FC<ButtonProps & Props> = ({
  name,
  sx,
  ...buttonProps
}) => {
  return (
    <OutlinedButton
      sx={(theme: Theme) => {
        const palette = theme.vars.palette;
        return {
          whiteSpace: 'nowrap',
          cursor: 'default',
          '&:hover': {
            background: palette.background.paper,
            border: `1.5px solid ${palette.primary.main}`,
          },
          border: `1.5px solid ${palette.grey.A100}`,
          background: palette.background.paper,
          height: 42,
          ...theme.applyStyles('dark', {
            '&:hover': { border: `1.5px solid ${palette.primary.light}` },
          }),
          ...sx,
        };
      }}
      size="small"
      {...buttonProps}
    >
      <Typography variant="body1" color="text.primary">
        {name}
      </Typography>
    </OutlinedButton>
  );
};
